import { useTranslation } from 'react-i18next';
import { getLandingContent } from '@/mocks/landingData';

export default function HowWeWorkSection() {
  const { i18n } = useTranslation();
  const { howWeWork } = getLandingContent(i18n.language);

  return (
    <section id="how-we-work" className="py-20 md:py-28 bg-white">
      <div className="px-6 md:px-10 lg:px-16">
        <div className="text-center mb-4">
          <p className="text-red-600 text-sm font-medium tracking-widest uppercase mb-4">
            {howWeWork.eyebrow}
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 md:mb-6">
            {howWeWork.title}
          </h2>
          <p className="text-base text-gray-500 max-w-2xl mx-auto mb-14 md:mb-20 leading-relaxed">
            {howWeWork.subtitle}
          </p>
        </div>

        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-7 gap-5 md:gap-6 xl:gap-4">
            {howWeWork.steps.map((step, index) => (
              <div key={step.step} className="relative flex flex-col items-center text-center">
                {index < howWeWork.steps.length - 1 && (
                  <div className="hidden xl:block absolute top-8 left-[55%] z-0 w-[90%] h-px bg-gray-200"></div>
                )}

                <div className="relative z-10 w-14 h-14 md:w-16 md:h-16 rounded-full bg-accent text-white flex items-center justify-center text-lg md:text-xl font-bold mb-5 flex-shrink-0 shadow-soft">
                  {step.step}
                </div>

                <div className="relative z-10 w-10 h-10 rounded-lg bg-red-50 flex items-center justify-center mb-4">
                  <i className={`${step.icon} text-red-600 text-base w-5 h-5 flex items-center justify-center`}></i>
                </div>

                <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-2 leading-snug">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
